import React, { FC } from 'react'
import styles from './styles.module.css'
import { useTranslation } from 'next-i18next'

type Props = {
  message: string
  onClose: () => void
}

export const BookingInvalidPopup: FC<Props> = ({ message, onClose }) => {
  const { t } = useTranslation()

  if (!message) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <img src="/modal_error_icon.webp" alt="" />
        <p className={styles.message}>{message}</p>
        <button onClick={() => onClose()} className={styles.closeButton}>
          <label>{t('COMMON.BACK')}</label>
        </button>
      </div>
    </div>
  )
}
